import { combineReducers } from 'redux';

export function error(state = null, action) {
    switch (action.type) {
        case 'SONG_AVAILABLE_ERROR':
            return action.error;

        case 'SONG_AVAILABLE_RESET':
            return null;

        default:
            return state;
    }
}

export function loading(state = false, action) {
    switch (action.type) {
        case 'SONG_AVAILABLE_LOADING':
            return action.loading;

        case 'SONG_AVAILABLE_RESET':
            return false;

        default:
            return state;
    }
}

export function data(state = {}, action) {
    switch (action.type) {
        case 'SONG_AVAILABLE_SUCCESS':
            return action.data;

        case 'SONG_AVAILABLE_RESET':
            return {};

        default:
            return state;
    }
}

export function picked(state = null, action) {
    switch (action.type) {
        case 'SONG_AVAILABLE_PICKED':
            return action.data;

        case 'SONG_AVAILABLE_RESET':
            return null;

        default:
            return state;
    }
}

export default combineReducers({ error, loading, data, picked });



// WEBPACK FOOTER //
// ./src/reducers/song/available.js